/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAuditLogsRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {GetAuditLogsResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const getAuditLogs = (request:GetAuditLogsRequest, options?: CashRequestOptions) => post<GetAuditLogsRequest, GetAuditLogsResponse>("/2.0/cash/get-audit-logs", request, {...options, rejectOnError: true })